export function addBackslashIfMissing(slug: string) {
    return slug.startsWith('/') || slug.startsWith('http') ? slug : `/${slug}`;
}
